var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 2,
  cx: 10,
  cy: 8.35,
  rx: 7,
  ry: 7.35
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2D2D2D",
  strokeWidth: 2,
  d: "M16.72 19.41L14 14.65"
})));
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0idGlueSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogIDxlbGxpcHNlIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJEMkQyRCIgc3Ryb2tlLXdpZHRoPSIyIiBjeD0iMTAiIGN5PSI4LjM1IiByeD0iNyIgcnk9IjcuMzUiLz4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMyRDJEMkQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTE2LjcyIDE5LjQxTDE0IDE0LjY1Ii8+Cjwvc3ZnPgo=";